export const ADMIN_CONSTANTS = {
	ERROR_FAILURE_ALL_ADMIN_COMPANY_STATUS: 'ERROR_FAILURE_ALL_ADMIN_COMPANY_STATUS',
	ERROR_FAILURE_CREATE_NEW_COMPANY_STATUS: 'ERROR_FAILURE_CREATE_NEW_COMPANY_STATUS',
	ERROR_FAILURE_UPDATE_COMPANY_STATUS: 'ERROR_FAILURE_UPDATE_COMPANY_STATUS',

}